module.exports = __webpack_public_path__ + "static/silhouette-girl1-8f2400caaa5d1852b6c8431cd2cd2776.svg";